import { REMOVE_SUGGESTION_ITEM, SET_SUGGESTIONS, SET_SUGGESTIONS_LOADING, SuggestionsActions } from '@Actions/suggestionsActions';

import { IUnexpensedItem } from '@Shared/expense_data';

interface ISuggestionsState {
  count: number;
  items: IUnexpensedItem[];
  loading: boolean;
}

export const defaultState: ISuggestionsState = {
  count: 0,
  items: [],
  loading: false
};

export function suggestionsReducer(state = defaultState, action: SuggestionsActions): ISuggestionsState {
  switch (action.type) {
    case SET_SUGGESTIONS: {
      return {
        ...state,
        count: action.payload.length,
        items: action.payload
      };
    }

    case SET_SUGGESTIONS_LOADING: {
      return {
        ...state,
        loading: action.payload
      };
    }

    case REMOVE_SUGGESTION_ITEM: {
      return {
        ...state,
        count: state.count - 1,
        items: state.items.filter((suggestion: IUnexpensedItem) => suggestion.card_transaction_id !== action.payload.card_transaction_id)
      };
    }

    default:
      return state;
  }
}
